<template>
  <div class="box-loading">
    <div class="loading">
        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
      </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
